module.exports = __webpack_public_path__ + "static/media/Two cuboids.0ab26e54.jpg";